import React from "react";
import { Link } from "react-router-dom";
import { Button } from "./ui/button";
import { Radio, ArrowRight, ExternalLink } from "lucide-react";

export const WLOKOnAirCard = ({ testId = "wlok-onair-card" }) => (
  <section className="bg-slate-950 border-b border-white/10 py-8" data-testid={testId}>
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="relative overflow-hidden rounded-2xl border border-cyan-400/30 bg-gradient-to-r from-slate-900 via-slate-950 to-slate-900 p-6 sm:p-8">
        <div className="absolute -top-16 -right-16 w-64 h-64 rounded-full bg-cyan-500/10 blur-3xl pointer-events-none" />
        <div className="flex flex-col md:flex-row items-start md:items-center gap-6">
          <Link to="/wlok" className="flex-shrink-0" data-testid={`${testId}-logo-link`}>
            <img
              src="/wlok-logo-tile.png"
              alt="WLOK AM 1340 · FM 105"
              className="w-28 h-28 sm:w-32 sm:h-32 rounded-2xl border border-cyan-400/40 shadow-lg hover:scale-105 transition-transform"
            />
          </Link>
          <div className="flex-1 min-w-0">
            <p className="text-[11px] font-black uppercase tracking-[0.3em] text-cyan-300 flex items-center gap-1.5">
              <Radio className="w-3.5 h-3.5" /> Labor on the Air · Memphis&apos; Legendary WLOK
            </p>
            <h2 className="text-white font-black text-xl sm:text-2xl mt-1.5 leading-tight">
              The Station That Has Always Stood With Working People
            </h2>
            <p className="text-slate-300 text-sm mt-2 leading-relaxed max-w-3xl">
              AM 1340 · FM 105 — the first Black-owned radio station in Memphis and a Tennessee Historical Landmark.
              CLC President Kevin Bradshaw joined the legendary Kermit Moore — President of the Memphis A. Philip Randolph
              Institute, President of the Memphis NAACP, and a retired USW member — on{" "}
              <span className="text-amber-300 font-semibold">The Rainbow PUSH Hour with Dr. Kevin Brooks</span> — a host
              who is spot on about labor and the community. He comes by it honestly: his mother was a union machinist
              right here in Memphis, and he was raised in organizing.
            </p>
            <div className="mt-4 flex flex-wrap gap-2.5">
              <Link to="/wlok">
                <Button className="bg-cyan-400 hover:bg-cyan-300 text-slate-950 font-bold h-9 px-4 text-sm" data-testid={`${testId}-partner-btn`}>
                  Meet WLOK — Community Partner <ArrowRight className="w-4 h-4 ml-1.5" />
                </Button>
              </Link>
              <a href="https://www.wlok.com" target="_blank" rel="noopener noreferrer">
                <Button variant="outline" className="bg-white/10 border-white/25 text-white hover:bg-white/20 font-semibold h-9 px-4 text-sm" data-testid={`${testId}-listen-btn`}>
                  <ExternalLink className="w-4 h-4 mr-1.5" /> Listen · wlok.com
                </Button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);
